import { CKBox } from '@clearkit/react';

import ContentBox from '~/components/ContentBox';
import { useFeatureFlag } from '~/hooks/account';
import {
  useHasAcquisitionsAccess,
  useHasConversionsAccess,
  useHasOperationsAccess,
} from '~/hooks/account/usePlatformAccess';
import {
  alwaysAvailableOnPlatformTypes,
  conversionsDestinationTypes,
  destinationTypeSalesforceCreateAccount,
  operationsDestinationTypes,
} from '~/lib/destinations';

import AddAcquisitionsPlan from './AddPlan/AddAcquisitionsPlan';
import AddConversionsPlan from './AddPlan/AddConversionsPlan';
import AddOperationsPlan from './AddPlan/AddOperationsPlan';
import {
  AddAudience,
  AddDestination,
} from './Destination/AddDestinationOrAudience';
import styles from './styles';
import { audienceSubTypesToShowAsDestinations } from './utils';

function PlatformPlanDestinations({ segment }) {
  const hasConversionsPlan = useHasConversionsAccess();
  const hasOperationsPlan = useHasOperationsAccess();
  const hasAcquisitionsPlan = useHasAcquisitionsAccess();
  const hasSalesforceCreate =
    useFeatureFlag('x_destination_create_salesforce_account').enabled &&
    segment.type === 'CompanySegment';

  let destinations = alwaysAvailableOnPlatformTypes();

  if (hasOperationsPlan) {
    destinations = destinations.concat(operationsDestinationTypes());
  }

  if (hasConversionsPlan) {
    destinations = destinations.concat(conversionsDestinationTypes(segment));
  }

  let audienceDestinations = [];

  if (hasAcquisitionsPlan) {
    audienceDestinations = audienceSubTypesToShowAsDestinations[segment.type];
  }

  if (hasSalesforceCreate) {
    destinations = destinations.concat([
      destinationTypeSalesforceCreateAccount,
    ]);
  }

  return (
    <div className="w-full divide-y divide-gray-200">
      <div className="mb-6">
        <ContentBox.Title className="mb-6 text-gray-600">
          <h2 className="mb-1 text-base font-medium">Available</h2>
          <p className="text-sm">This is what you can do</p>
        </ContentBox.Title>

        {destinations.map((destinationType) => (
          <CKBox key={destinationType} className="mb-4">
            <AddDestination
              className=""
              type={destinationType}
              segment={segment}
            />
          </CKBox>
        ))}

        {audienceDestinations.map((audienceType) => (
          <CKBox key={audienceType} className="mb-4">
            <AddAudience
              key={audienceType}
              subtype={audienceType}
              segment={segment}
            />
          </CKBox>
        ))}
      </div>

      {(hasAcquisitionsPlan && hasConversionsPlan && hasOperationsPlan) || (
        <div className="flex flex-col pt-4 gap-8">
          <ContentBox.Title className=" text-gray-600">
            <h2 className="mb-1 text-base font-medium">
              Do more with Clearbit
            </h2>
            <p className="text-sm">
              Contact our success team to learn how we can help you achieve your
              goals by putting data to work.
            </p>
          </ContentBox.Title>

          <AddOperationsPlan segment={segment} />
          <AddAcquisitionsPlan segment={segment} />
          <AddConversionsPlan segment={segment} />
        </div>
      )}
    </div>
  );
}

export default withStyles(styles)(PlatformPlanDestinations);
